import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Form, Modal, message } from "antd";
import { getErrorProps } from "@utils/helpers";
import { ButtonComponent, InputText } from "@comps/components";
import { MailOutlined } from "@ant-design/icons";
import { forget } from "../requests";
import "./SignIn.css"
import RecoverPassword from "./RecoverPassword";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { authTooltips } from "../../common/authTooltips";

const fieldLabel = makeFieldLabel(authTooltips.auth, { namespace: "auth" });

const ForgotPassword = ({ visible, onCancel }) => {
  const { loaderState, errors } = useSelector((state) => state.auth);
  const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);


  const [form] = Form.useForm();


  const onFinish = async (values) => {
    setLoading(true);
    const res = await forget({ email: values.email });
    setLoading(false);

    if (res?.success || res?.code === 200) {
      form.resetFields();
      onCancel();
      showForgotPasswordModal();
      return;
    }

    const errorMessage = res?.response?.data?.message || res?.message || "Unable to send reset link. Please try again.";
    form.setFields([
      {
        name: "email",
        errors: [errorMessage],
      },
    ]);
    message.warning(errorMessage);
  };

  const showForgotPasswordModal = () => {
    setForgotPasswordVisible(true);
  };

  const closeForgotPasswordModal = () => {
    setForgotPasswordVisible(false);
  };



  return (
    <div style={ { background: '#F3F6F9' } }>
      <Modal open={ visible } onCancel={ onCancel } footer={ null }>
        <img src="./loginicon/Vec.svg" alt="not found" style={ { marginLeft: 80, marginTop: 50 } } />
        <img src="./loginicon/sad.svg" alt="not found" style={ { marginLeft: 130, marginTop: -250 } } />
        <img src="./loginicon/Vec2.svg" alt="not found" style={ { marginLeft: -240, marginTop: -130, width: 30 } } />
        <img src="./loginicon/Vec1.svg" alt="not found" style={ { marginLeft: 245, marginTop: -250 } } />
        <img src="./loginicon/Vec3.svg" alt="not found" style={ { marginLeft: 135, marginTop: -390 } } />
        <img src="./loginicon/Vec2.svg" alt="not found" style={ { marginLeft: 130, marginTop: -360 } } />

        <h1 className="klok-forgot">Forgot Password?</h1>
        <p className="klok-forgot-text">
          Forgot Password? Don’t worry we are here to recover your password
        </p>
        <Form form={ form } onFinish={ onFinish }
          style={ { marginTop: 60 } }
          layout="vertical"
          name="basic"
          initialValues={ { remember: true } }
          className="da-mt-sm-16 da-mt-32"
        >
          <Form.Item
            name="email"
            rules={ [
              { required: true, message: "Please input your email!" },
              { type: "email", message: "Please enter a valid email address." },
            ] }
            label={ fieldLabel("email", "Email address") }
            className="da-mb-16"
            { ...getErrorProps(errors?errors['email']:'') }
          >
            <InputText
              placeholder="Enter your Email"
              style={ {
                height: 56,
              } }
              prefix={ <MailOutlined /> }
            />
          </Form.Item>

          <Form.Item className="da-mt-16 da-mb-8">
            <ButtonComponent className="actionButton" type="primary" htmlType="submit" state={ loaderState } loading={ loading }>
              Recover Your Password
            </ButtonComponent>
          </Form.Item>
        </Form>
      </Modal>
      <RecoverPassword
        visible={ forgotPasswordVisible }
        onCancel={ closeForgotPasswordModal }
      />
    </div>
  );
};

export default ForgotPassword;
